import { decisionApi, removeLock, submitReviewNote } from "../api/review";

export const handleDecision = async (
  applicationId,
  body,
  setIsAcceptModalVisible,
  setIsRejectModalVisible,
  navigate
) => {
  try {
    const response = await decisionApi(applicationId, body);
    console.log("Response: ", response)
    console.log("API Response Data:", JSON.stringify(response.data, null, 2)); // Safe logging

    if (response) {
      if (body?.decision === "APPROVE") {
        console.log("Accepted");
        setIsAcceptModalVisible(false);
      } else {
        console.log("Rejected");
        setIsRejectModalVisible(false);
      }
      navigate("/dashboard");
    } else {
      console.error("Error occurred while calling decision API");
    }
  } catch (error) {
    setIsAcceptModalVisible(false);
    setIsRejectModalVisible(false);
    console.error("Unexpected error in handleDecision:", error);
    throw error;
  }
};

export const submitViewedNote = async (applicationId, action, setIsPopupOpen, setPopupMessage, setIsLocked, setLockCode) => {
  try {
    if (!applicationId) {
      throw new Error('Application ID is required');
    }

    const user = JSON.parse(sessionStorage.getItem('user'));
    console.log("user: ", user)

    const reviewNoteBody = {
      reviewerID: user?.userId,
      reviewername: user?.name,
      loa: "",
      notes: "Viewed"
    };

    const response = await submitReviewNote(applicationId, action, reviewNoteBody);
    if (typeof response.code !== 'undefined' && response.code === "REVIEW_LOCKED") {
      setIsLocked(true);
      setIsPopupOpen(true);
      setPopupMessage("This application is currently locked for review. Please try after sometime.");
      setLockCode("Application under review");
      return true;
    }
    if (typeof response.code !== 'undefined' && response.code === "SELF_LOCKED") {
      setIsLocked(true);
      setIsPopupOpen(true);
      setPopupMessage("Looks like you are already reviewing another application. Please close that application to view this one.");
      setLockCode("Application not available for review");
      return true;
    }
    return false;
  } catch (error) {
    console.error("Error occurred while adding view note when application is viewed", error);
    let errorMessage = "An unexptected error occurred";
    setIsPopupOpen(true);
    setPopupMessage(errorMessage);
    return true;
  }
}

export const removeReviewLock = async (applicationId, body) => {
  try {
    const response = await removeLock(applicationId, body);
    if (!response) {
      throw new Error("Invalid response structure");
    }
    return response;
  } catch (error) {
    console.error("Unexpected error in removeReviewLock:", error.message);
    return null;
  }
}
